module.exports = __webpack_public_path__ + "static/media/unit 1-1.5ac5565e.jpg";